import {Attachment} from '@hconnect/common/types'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {deleteActionAttachment, QueryKeyName} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'

interface DeleteActionAttachmentArgs {
  plantId: string
  actionId: number
  attachment: Attachment
}

export const useDeleteActionAttachment = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({plantId, actionId, attachment}: DeleteActionAttachmentArgs) => {
      return deleteActionAttachment({plantId, actionId, documentId: attachment.url})
    },
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetActionItems]})
      spawnSuccessToast(t('attachments.deleted.success'))
    },
    onError: () => {
      spawnErrorToast(t('attachments.deleted.error'))
    }
  })
}

